/* eslint-disable import/prefer-default-export */

import { isValidPostalCode } from '../../../shared/postalCodeUtils';

const hasValue = (value) => {
  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === 'boolean') {
    return true;
  }

  return value !== null && value !== undefined && value.toString().trim().length > 0;
};

const urlIsValid = (url) => {
  try {
    const parsed = new URL(url);
    return ["http:", "https:"].includes(parsed.protocol);
  } catch (_error) {
    return false;
  }
};

const emailIsValid = (email) => {
  return /^\S+@\S+\.\S+$/.test(email);
};

const numberIsValid = (numberValue) => {
  return /^-?\d+(\.\d+)?$/.test(numberValue);
};

const checkboxValueIsValid = (checkboxValue) => {
  return ["true", "false", true, false, "1", "0", 1, 0].includes(checkboxValue);
};

export const addressHasAnyValues = (addressValue = {}) => (
  Object.entries(addressValue).some(([key, v]) => key !== 'country' && (typeof v === 'number' || (v && v.length > 0)))
);

export const canSubmitCustomFieldValue = (customFieldValue, { requireCheckedCheckbox = false } = {}) => {
  var canSubmit = false;
  const required = customFieldValue.custom_field.required;

  switch (customFieldValue.type) {
    case 'CustomFieldValues::Address':
      var addressValue = customFieldValue.value || {};
      var hasAnyValues = addressHasAnyValues(addressValue);
      var country = addressValue.country || 'US';

      if(hasAnyValues){
        canSubmit = (
          addressValue.address1
            && addressValue.address1.length > 0
            && addressValue.city
            && addressValue.city.length > 0
            && addressValue.state
            && addressValue.state.length > 0
            && addressValue.zip
            && addressValue.zip.length > 0
            && isValidPostalCode(addressValue.zip, country)
        );
      } else {
        canSubmit = (
          !required
        );
      }

      break;
    case 'CustomFieldValues::Phone':
      var nonDigit = /\D/ig;
      var phoneNumber = (customFieldValue.value || "").replace(nonDigit, "");

      if(phoneNumber.length > 0){
        canSubmit = (
          phoneNumber.length === 10
        );
      } else {
        canSubmit = (
          !required
        );
      }

      break;
    case 'CustomFieldValues::Select':
      canSubmit = !required || hasValue(customFieldValue.value);
      break;
    case 'CustomFieldValues::Checkbox':
      if (required && requireCheckedCheckbox) {
        canSubmit = [true, 'true'].includes(customFieldValue.value);
      } else {
        canSubmit = !required || checkboxValueIsValid(customFieldValue.value);
      }
      break;
    case 'CustomFieldValues::Email':
      if (hasValue(customFieldValue.value)) {
        canSubmit = emailIsValid(customFieldValue.value);
      } else {
        canSubmit = !required;
      }
      break;
    case 'CustomFieldValues::Url':
      if (hasValue(customFieldValue.value)) {
        canSubmit = urlIsValid(customFieldValue.value);
      } else {
        canSubmit = !required;
      }
      break;
    case 'CustomFieldValues::Number':
      if (hasValue(customFieldValue.value)) {
        canSubmit = numberIsValid(customFieldValue.value);
      } else {
        canSubmit = !required;
      }
      break;
    case 'CustomFieldValues::File':
      canSubmit = (
        !required
        || !!customFieldValue.uploaded_file
        || !!customFieldValue.uploaded_file_name
        || !!customFieldValue.value
      );
      break;
    default:
      canSubmit = !required || hasValue(customFieldValue.value);
  }

  return canSubmit;
}

export const customFieldValueToParams = (customFieldValue) => {
  var params = {
    id: customFieldValue.id,
    custom_field_id: customFieldValue.custom_field.id,
    type: customFieldValue.type
  };

  if (customFieldValue.ticket_type_id != null) {
    params.ticket_type_id = customFieldValue.ticket_type_id;
    params.ticket_index = customFieldValue.ticket_index;
  }

  switch (customFieldValue.type) {
    case 'CustomFieldValues::Address':
      var addressValue = customFieldValue.value || {};
      params = Object.assign({}, params, {
        address1: addressValue.address1,
        address2: addressValue.address2,
        city: addressValue.city,
        state: addressValue.state,
        zip: addressValue.zip,
        country: addressValue.country || 'US'
      });
      break;
    case 'CustomFieldValues::Phone':
      var nonDigit = /\D/ig;

      params = Object.assign({}, params, {
        value: (customFieldValue.value || "").replace(nonDigit, "")
      });
      break;
    case 'CustomFieldValues::Checkbox':
      params = Object.assign({}, params, {
        value: customFieldValue.value === true || customFieldValue.value === "true" ? "true" : "false"
      });
      break;
    case 'CustomFieldValues::File':
      params = Object.assign({}, params, {
        value: customFieldValue.value
      });

      if (customFieldValue.uploaded_file instanceof File) {
        params = Object.assign({}, params, {
          uploaded_file: customFieldValue.uploaded_file
        });
      }
      break;
    default:
      params = Object.assign({}, params, {
        value: customFieldValue.value
      });
  }

  return params;
}
